// extracted by mini-css-extract-plugin
export default {"image_block":"ScrollableImage_image_block__P--5P"};